export default {"src":"/_next/static/media/News-Icon.46a0f3b8.svg","height":591,"width":591,"blurWidth":0,"blurHeight":0};